import { ComponentPropsWithoutRef, FC, ReactNode } from 'react';

import { Icon, IconSource, type Props as IconProps } from '../Icon/Icon';
import { Stack } from '../Stack/Stack';
import { getIconColor, StyledBadge } from './Badge.styles';

export const variations = ['primary', 'success', 'info', 'error', 'warning', 'default'] as const;
export const types = ['subtle', 'loud'] as const;

export type Variation = (typeof variations)[number];
export type Type = (typeof types)[number];

export type Props = {
	children: ReactNode;
	variation?: Variation;
	type?: Type;
	icon?: IconSource;
	/** Passed to the leading Icon (e.g. aria-hidden when the label text is sufficient). */
	iconProps?: Partial<Omit<IconProps, 'source'>>;
	rounded?: boolean;
	numeric?: boolean;
};

export const Badge: FC<ComponentPropsWithoutRef<'span'> & Props> = ({
	children,
	variation,
	type = 'subtle',
	icon,
	iconProps,
	...rest
}) => (
	<StyledBadge variation={variation} type={type} {...rest}>
		<Stack align="center" spacing="extraTight">
			{icon && <Icon color={getIconColor(variation, type)} size={'small'} source={icon} {...iconProps} />}
			{children}
		</Stack>
	</StyledBadge>
);
